//I Would Highly Recommend You To Customize The Theme According To Your Taste.
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#48a9fe,#00cdac)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 74%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #06bcfb 0%, #4884ee 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#00cdac",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "<Bharanishwaran>";

// Main Page
export const main = {
  name: "Bharanishwaran",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://drive.google.com/file/d/13jJR8gjQvhWyMV9_8VcbRBVteuZ_F-c9/view?usp=sharing",
  linkedin:"https://www.linkedin.com/in/bharanishwaran-m/",
  github:"https://github.com/Bharani619"  
};

// AboutMe
export const aboutme = {
  imgLink:
    "https://avatars.githubusercontent.com/u/97450375?s=400&u=8f34fee4feaf46672922df573d65b3238a735557&v=4",
  p1: "Hey, My name is Bharanishwaran. I have completed my Bachelor of Engineering from Paavai college of Engineering, Namakkal, Tamilnadu",
  p2: " A Frontend focused Web Developer building the Frontend of Websites and Web Applications.",
  p3: "Apart from coding I like traveling and reading books.",
};

// Skills
export const whatido = {
  title: "Full Stack Development",

  details: [
    "Building responsive website using HTML,CSS,JS,React",
    "Knowledge about how to use Json-server",
    "Knowledge of various UI libraries",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    // {
    //   name: "NodeJS",
    //   iconifyClassName: "logos:nodejs",
    //   id: "6",
    // },
    // {
    //   name: "ExpressJS",
    //   iconifyClassName: "logos:express",
    //   id: "7",
    // },
    // {
    //   name: "MongoDB",
    //   iconifyClassName: "logos:mongodb",
    //   id: "8",
    // },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    // {
    //   name: "Tailwind",
    //   iconifyClassName: "logos:tailwindcss-icon",
    //   id: "12",
    // },
    {
      name: "Material-UI",
      iconifyClassName: "logos:material-ui",
      id: "13",
    },
    // {
    //   name: "Ant Design",
    //   iconifyClassName: "logos:ant-design",
    //   id: "14",
    // },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
    {
      name: "Vercel",
      iconifyClassName: "logos:vercel-icon",
      id: "16",
    },
  ],
};

// Project Details
export const details = [
  {
    id: 1,
    title: "Boat Lifestyle",
    desc: `Boat is the online electronics products website which offers customer for various audio products..`,
    feature: `Sign-in/Sign-up validation,
    corousel image,
payment gateway,Dynamic cart page with coupon functionality.`,
    tech: `Tech Stack: HTML| CSS | JavaScript | Netlify`,
    img: "https://cdn-images-1.medium.com/max/1040/1*R374OPJAR49Wq_tki5ZcQA.png",
    github: "https://github.com/Bharani619/Boat-clone",
    link: "https://boatclone68d310.netlify.app/"
  },
  {
    id: 2,
    title: "Mamaearth",
    desc: `Mamaearth is online store which offers Non-Toxic Beauty products.`,
    feature: `Sign-in/Sign-up,
    explore various beauty cares products,
    cart functionality.`,
    tech: `Tech Stack: HTML | CSS | JavaScript | React JS | Netlify`,
    img: "https://cdn-images-1.medium.com/max/1040/1*StPsEPuvTr08P69H4XpX-w.png",
    link: "https://clone-mamaearth.netlify.app/",
    github: "https://github.com/Bharani619/Clone_MamaEarth",
  },
  
];

// Social Media Links
export const links = [
  
  "https://www.linkedin.com/in/bharanishwaran-m/",
  "https://twitter.com/bharani168",
  // "https://api.whatsapp.com/send/?phone=918109560498&text&app_absent=0",
  "mailto:bharanish619@gmail.com",
  "https://github.com/Bharani619",
];
